/** @jsxImportSource theme-ui */
import React from 'react';
import { useSelector } from 'react-redux';
import { SxProp } from 'theme-ui';

import { InsightsState } from 'app-redux/InsightsState';
import * as dto from 'client/dto';

import { Typography } from 'components/_common/Typography';

import diseasesSelectors from 'diseases/diseases.selectors';
import riskOverviewSelectors from 'riskOverview/riskOverview.selectors';

import BepiDetails from '../../bepi/components/BepiDetails';
import RiskOverviewCardPreventabilityDetails from './RiskOverviewCardPreventabilityDetails';
import RiskOverviewCardSeverityDetails from './RiskOverviewCardSeverityDetails';
import RiskOverviewCardTransmissibilityDetails from './RiskOverviewCardTransmissibilityDetails';
import { disruptionPanelStyle } from './RiskOverviewStyles';

type RiskOverviewCardDisruptionDetailsProps = SxProp & {
  diseaseActivityId: number;
  locationId: number;
  hideBepi?: boolean;
};

const RiskOverviewCardDisruptionDetails: React.FC<RiskOverviewCardDisruptionDetailsProps> = ({
  locationId,
  diseaseActivityId,
  hideBepi = false,
  ...props
}) => {
  const riskFeedEntry: dto.RiskFeedEntryModel = useSelector((state: InsightsState) =>
    riskOverviewSelectors.getRiskFeedEntryByActivityIdAndLocationId(state)
  )(diseaseActivityId, locationId);
  const diseaseName = useSelector(diseasesSelectors.getDiseaseName(riskFeedEntry?.diseaseId));

  return (
    <div {...props}>
      <div className="ro-disruption-panel-container" sx={disruptionPanelStyle}>
        <Typography variant="subtitle1" color="stone90">
          {diseaseName} Risk Factors
        </Typography>

        <RiskOverviewCardTransmissibilityDetails
          locationId={locationId}
          diseaseActivityId={diseaseActivityId}
        />
        <RiskOverviewCardPreventabilityDetails
          locationId={locationId}
          diseaseActivityId={diseaseActivityId}
        />
        <RiskOverviewCardSeverityDetails
          locationId={locationId}
          diseaseActivityId={diseaseActivityId}
        />
      </div>
      {!hideBepi && <BepiDetails locationId={locationId} />}
    </div>
  );
};

export default RiskOverviewCardDisruptionDetails;
